import { errorImg, noResultsImage } from 'utils/assets/images';

import { Button, Flex, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

interface IListTablePlaceholder {
  isError: boolean;
  onClear?: () => void;
  showClearButton: boolean;
  title: string;
}

export function ListTablePlaceholder({
  isError,
  onClear,
  showClearButton,
  title,
}: IListTablePlaceholder) {
  const { t } = useTranslation();
  const config = isError
    ? {
        src: errorImg,
        title: 'core.searchErrorTitle',
        text: 'core.searchErrorDescription',
        color: 'status.danger.700',
      }
    : {
        src: noResultsImage,
        title: 'core.searchNoResultsTitle',
        text: 'core.searchNoResultsDescription',
        color: '',
      };

  return (
    <Flex
      orientation="vertical"
      align="center"
      justify="center"
      css={{ flex: 1 }}
    >
      <Typography
        variant="title"
        css={{ color: config.color, marginBottom: 2 }}
        children={t(config.title)}
      />
      <Typography
        variant="body"
        css={{ maxWidth: '320px', marginBottom: '$large' }}
        children={t(config.text, { title })}
      />
      <Button
        variant="secondary"
        isDisabled={!showClearButton}
        onPress={onClear}
        children={t('core.clearSearch')}
      />
      <Flex css={{ maxWidth: 530 }}>
        <img
          src={config.src}
          alt={config.title}
          style={{ height: 'auto', maxWidth: '100%' }}
        />
      </Flex>
    </Flex>
  );
}
